import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type WorkersEvents = 'TABLE_CELL_CLICK' | 'EXPORT_WORKERS_RESULT';

export const workers: Record<WorkersEvents, MixpanelEvent> = {
  TABLE_CELL_CLICK: {
    eventKey: 'table-cell-click',
    eventDescription: 'Table Cell Click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  EXPORT_WORKERS_RESULT: {
    eventDescription: 'Export Workers Result',
    eventKey: 'export-workers-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  }
} as const;
